import { memo } from "react";
import { ShieldCheck, PackageCheck, Truck, Zap, MapPin } from "lucide-react";
import postnordLogo from "@/assets/postnord-logo.svg";
import revolutLogo from "@/assets/revolut-logo.svg";
import visaMastercardLogo from "@/assets/visa-mastercard-logo.webp";

/**
 * TrustBarLogos - Premium trust bar with upgraded visuals
 */

const trustIcons = [
  { icon: ShieldCheck, text: "100% lagligt" },
  { icon: MapPin, text: "Skickas från Sverige" },
  { icon: Truck, text: "Fri frakt 499+" },
  { icon: Zap, text: "Snabb leverans" },
];


export const TrustBarLogos = memo(() => {
  return (
    <section className="border-y border-border">
      {/* Payment & Shipping logos - compact single row on mobile */}
      <div className="bg-card py-5 md:py-10 border-b border-border/50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center gap-6 md:gap-16">
            <div className="flex items-center">
              <div className="h-7 md:h-12 flex items-center">
                <img src={postnordLogo} alt="PostNord leverans – Skickas från Sverige" className="h-full w-auto object-contain brightness-150" loading="lazy" width="120" height="28" />
              </div>
            </div>
            <div className="w-px h-8 md:h-16 bg-border" />
            <div className="flex items-center gap-3">
              <div className="h-6 md:h-10 flex items-center">
                <img src={revolutLogo} alt="Revolut betalningar" className="h-full w-auto object-contain" style={{ filter: 'brightness(0) invert(1)' }} loading="lazy" width="80" height="24" />
              </div>
              <div className="h-5 md:h-8 flex items-center">
                <img src={visaMastercardLogo} alt="Visa och Mastercard" className="h-full w-auto object-contain brightness-125" loading="lazy" width="76" height="19" />
              </div>
            </div>
          </div>
          <div className="flex justify-center gap-6 mt-3">
            <span className="text-xs md:text-sm text-muted-foreground">Diskreta paket</span>
            <span className="text-xs md:text-sm text-muted-foreground">Krypterade betalningar</span>
          </div>
        </div>
      </div>

      {/* Trust icons bar */}
      <div className="bg-card/80 py-6 md:py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:gap-x-16">
            {trustIcons.map((item, i) => (
              <div key={i} className={`flex flex-col items-center gap-2 group ${i === 3 ? 'hidden md:flex' : ''}`}>
                <div className="relative">
                  <item.icon className="w-7 h-7 md:w-8 md:h-8 text-primary group-hover:scale-110 transition-transform duration-200" />
                </div>
                <span className="text-sm font-medium text-muted-foreground">
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
});

TrustBarLogos.displayName = "TrustBarLogos";
export default TrustBarLogos;
